module.exports = __webpack_public_path__ + "img/logo.07064203.png";